// extracted by mini-css-extract-plugin
export var bubble = "_3w-0";
export var container = "_3w-f";
export var contrastBorder = "_3w-g";
export var greyOut = "_3w-2";
export var initialsColor0 = "_3w-3";
export var initialsColor1 = "_3w-4";
export var initialsColor10 = "_3w-d";
export var initialsColor11 = "_3w-e";
export var initialsColor2 = "_3w-5";
export var initialsColor3 = "_3w-6";
export var initialsColor4 = "_3w-7";
export var initialsColor5 = "_3w-8";
export var initialsColor6 = "_3w-9";
export var initialsColor7 = "_3w-a";
export var initialsColor8 = "_3w-b";
export var initialsColor9 = "_3w-c";
export var initialsWrapper = "_3w-1";
export var large = "_3w-l";
export var medium = "_3w-k";
export var mediumSmall = "_3w-j";
export var mediumSmallMedium = "_3w-o";
export var micro = "_3w-h";
export var small = "_3w-i";
export var tiny = "_3w-n";
export var xTiny = "_3w-m";